export default __webpack_public_path__ + "static/media/p-1.b5aee572.jpg";